import { Box } from '@mantine/core'
import { type SearchParameters } from 'algoliasearch-helper'
import React, { useEffect, useMemo } from 'react'
import { Configure, useInstantSearch } from 'react-instantsearch'
import { BasePageLayout } from './BaseLayout'

export const ShopPageLayout = ({
  searchParameters,
  setResults,
  showResultsCount = true,
  rootCategory,
  ...rest
}: React.ComponentProps<typeof BasePageLayout> & {
  searchParameters: SearchParameters
  setResults?: (results: number | undefined) => void
  rootCategory?: string
}) => {
  const { results } = useInstantSearch()
  const memoizedParams = useMemo(
    () => searchParameters,
    [JSON.stringify(searchParameters)]
  )

  useEffect(() => {
    setResults?.(results?.nbHits)
  }, [results?.nbHits, setResults])

  return (
    <Box>
      <Configure {...memoizedParams} />
      <BasePageLayout
        showResultsCount={showResultsCount}
        rootCategory={rootCategory}
        {...rest}
      />
    </Box>
  )
}
